//react
import React, { Component } from 'react';

//components
import Translation from '../../components/translation/translation';

//data
import dataTranslations from './translations.json';

//assets
import './popup.css';

class PopupReportASideEffect extends Component {
	render() {
		return (
			<div className="popup">
				<div className="popup__inner">
					<p><Translation culture={this.props.culture} data={dataTranslations.reportASideEffect} name="line1" /></p>
					<p><Translation culture={this.props.culture} data={dataTranslations.reportASideEffect} name="line2" /></p>
					<ul>
						<li><Translation culture={this.props.culture} data={dataTranslations.reportASideEffect} name="bullet1" /></li>
						<li><Translation culture={this.props.culture} data={dataTranslations.reportASideEffect} name="bullet2" /></li>
					</ul>
					<p>
						<a className="popup__button hwa" href={this.props.url} onClick={(event) => this.props.close(event, false)} rel="noopener noreferrer" target="_blank"><Translation culture={this.props.culture} data={dataTranslations.reportASideEffect} name="agree" /></a>
						<button className="popup__button popup__button--close hwa" onClick={(event) => this.props.close(event, true)}><Translation culture={this.props.culture} data={dataTranslations.reportASideEffect} name="close" /></button>
					</p>
				</div>
			</div>
		);
	}
}

export default PopupReportASideEffect;



// WEBPACK FOOTER //
// ./src/components/popup/reportASideEffect.js